import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { Toaster } from "./components/ui/sonner";
import "./styles/global.css";
import "./styles/home.css";
import "./styles/about.css";
import "./styles/contact.css";
import "./styles/legal.css";

function App() {
  const [language, setLanguage] = useState('en');

  return (
    <div className="App">
      <BrowserRouter>
        <Navigation language={language} setLanguage={setLanguage} />
        <Routes>
          <Route path="/" element={<Home language={language} />} />
          <Route path="/about" element={<About language={language} />} />
          <Route path="/contact" element={<Contact language={language} />} />
          <Route path="/privacy" element={<Privacy language={language} />} />
          <Route path="/terms" element={<Terms language={language} />} />
        </Routes>
        <Footer language={language} />
        <CookieBanner />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
